module.exports = __webpack_public_path__ + "img/richard_bower_co.cffc427d.png";